<template>
    <div>
        <div class="Breadcrumb">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item><a href="/">首页</a></el-breadcrumb-item>
                <el-breadcrumb-item v-if="classify == 'information'">政策信息</el-breadcrumb-item>
                <el-breadcrumb-item v-else>公告公示</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <ul class="newlist">
            <li v-for="item in information" :key="item.id"><a v-if="item.isLinkNews == 0" target="_blank" :href="url2 + information.indexOf(item)+ '/'+this.classify+'/'+ currentPage" :title="item.TITLE">{{ item.TITLE }}</a> <a v-if="item.isLinkNews != 0" target="_blank" :href="item.linkURL" :title="item.TITLE">{{ item.TITLE }}</a> <p>{{ item.DATE.slice(0,10) }}</p></li>
          </ul>
          <div class="pagination">
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="currentPage"     @current-change="handleCurrentChange"
             />
        </div>
    </div>
</template> 

<script>
import {ref} from 'vue'

export default {
    name: "NewList",
    setup(){
        const total = ref(150)
        const pageSize = ref(15)
        const currentPage = ref(1)
        return{
            total,
            pageSize,
            currentPage
        }
    },
    props: {
        classify: String
    }, 
    data(){
        return{
            information:[],
            url2: '/newdetail/'
        }
    },
    methods:{
        getInformation(page,count){
            console.log(this.classify)
            let category = this.classify == 'information' ? '政策信息' : '公告公示';
                this.$axios.post('/api/Book/UrlList',{
                    category: category,
                    page: page,
                    count:count
                }).then(res=>{
                    if(this.classify == 'information'){
                        res.data.政策信息.forEach(item=>{
                            item.DATE = item.DATE.split(' ')[0];
                        });
                        this.information = res.data.政策信息;
                        this.total = res.data.TOTAL;
                    }
                    else if(this.classify == 'notice'){
                        res.data.公告公示.forEach(item=>{
                            item.DATE = item.DATE.split(' ')[0];
                        });
                        this.information = res.data.公告公示;
                        this.total = res.data.TOTAL;
                    }
                })
            },
        handleCurrentChange(val){
            this.currentPage = val;
            this.getBookList(val,this.pageSize)
        }
    },
    created(){
        this.getInformation(1,15);
    }
}
</script>

<style scoped>
.el-pagination{
    margin-top: 20px;
    float: right;
}
.pagination{
    margin-right: 320px;
    float: right;
}

.newlist li a{
    text-decoration: none;
    color: #464545;
    font-size: 20px;
    width: 85%;
    float: left;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.newlist li p{
    width: 15%;
    font-size: 20px;
    float: right;
    text-align: right;
}
.newlist li{
    list-style: none;
    width: 1350px;
    height: 40px;
    margin-left: 20px;
    margin-top: 20px;
    float: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
}
.newlist{
    width: 1400px;
    height: 100%;
    margin-left: 250px;
    margin-top: 10px;
    float: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
    border: rgb(63, 142, 231) 1px solid;
}
.el-breadcrumb{
    margin-top: 20px;
    margin-left: 270px;
    height: 60px;
    font-size: 16px;
    color: #c1c6c9;
    float: left;
}
.Breadcrumb{
    width: 1903px;
    height: 60px;
    background: #f5f6f6;
    margin-left: -20px;
    float: left;
}
</style>